/* ================================================
   pw-accordions.js
   PilgrimWaters — generalized accordion handler
   Uses capture phase to bypass stopPropagation.
================================================ */

(function () {
  'use strict';

  function init() {
    var groups = document.querySelectorAll('.pw-accordion-group');

    groups.forEach(function (group) {
      var buttons = Array.prototype.slice.call(
        group.querySelectorAll('.accordion-button[data-panel]')
      );

      function closeBtn(btn) {
        var panel = document.getElementById(btn.getAttribute('data-panel'));
        if (!panel) return;
        panel.style.maxHeight = null;
        panel.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        var icon = btn.querySelector('.accordion-icon');
        if (icon) icon.textContent = '+';
      }

      function openBtn(btn) {
        var panel = document.getElementById(btn.getAttribute('data-panel'));
        if (!panel) return;
        panel.style.maxHeight = panel.scrollHeight + 'px';
        panel.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        var icon = btn.querySelector('.accordion-icon');
        if (icon) icon.textContent = '−';
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var wasOpen = btn.getAttribute('aria-expanded') === 'true';
          buttons.forEach(function (b) { closeBtn(b); });
          if (!wasOpen) { openBtn(btn); }
        }, true); /* true = capture phase */
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
